<body>
    <!-- <app-account-header></app-account-header> -->
    <nav class="navbar navbar-expand-md navbar-dark navbar-white fixed-top mb-5">
      <!-- <div class="row"> -->
        <div class="menu outline-0 cp"><img class="tablogo" src="./assets/images/tl-215.png"  /></div>
      </nav>
      <div class="clear40"></div>
    
      <div class="d-flex align-items-center auth px-0 mt-5">
        <div class="row w-100 mx-0 mt-3">
          <div class="col-lg-4 mx-auto">
            <!-- <label class="txtblack fs-20 semi-bold"><img routerLink="/account-details" class="mr-2 cp outline-0" src="./assets/images/backarrow.png">Change Password</label> -->
            <label class="txtblack fs-20 semi-bold">Change Password</label>
            <div class="clear5"></div>
            <div class="auth-form-light bg-white">
            
              <form >
                <h6 class="fs-16 txtblack semi-bold mb-3">Enter Current Password</h6> 
                <div class="form-group">
                  <input type="{{typeCurrent}}"  class="form-control forminput {{showcurrentpassErrorMsg?'border-red':''}}"  [(ngModel)]="oldPassword" (input)="currentpassErrorMsg();" name ="oldPassword"  placeholder="Current Password" autocomplete="off">
                  
                  <!-- <img src="./assets/images/eye.png" class="cp password-img img-responsive cp" (click)="toggleShowCurrent()"> -->
              
                  <span class="error-msg" *ngIf="showcurrentpassErrorMsg">Please Enter Current Password</span>
  
                </div>
     
                <!-- <h6  class="blue-link semi-bold cp" routerLink="/forgot-password-alogin">Forgot Password</h6>
                <div class="clear20"></div>
                <div class="bottom-border mb-3"></div> -->
                <div class="clear5"></div>
    
                <h6 class="fs-16 txtblack semi-bold mb-3">Enter New Password</h6> 
                <div class="form-group m-0 password-input">
                  
                  <input type="{{typeNew}}"  class="form-control forminput {{shownewpassErrorMsg?'border-red':''}}"  [(ngModel)]="newPassword" (input)="newpassErrorMsg();passwordValidate(newPassword)" name="newPassword"  placeholder="New Password" autocomplete="off">
                  <img src="./assets/images/eye.png" class="cp password-img img-responsive cp" (click)="toggleShowNew()">
                </div>
                  <span class="error-msg" *ngIf="shownewpassErrorMsg">Please Enter New Password</span>
                
                <p class="fs-12 regular">* Password must be between 8-16 characters and include at least one upper-case letter, one lower-case letter, one number, and one special character. Special characters allowed: !@#$%^&*()-+</p>
                <div class="col-12 col-sm-12 col-md-12 col-lg-12" style="color: red;" *ngIf="error5">
                  {{error5}}
                </div> 
                <div class="clear5"></div>
                <h6 class="fs-16 txtblack semi-bold mb-3">Confirm New Password</h6> 
                <div class="form-group  m-0 password-input">
                  <input type="{{typeConfirm}}"  class="form-control forminput {{showconfirmpassErrorMsg?'border-red':''}}"  name="newPassword1" [(ngModel)]="confirmPassword" (input)="confirmpassErrorMsg();"   placeholder="Confirm Password" autocomplete="off">
                  <img src="./assets/images/eye.png" class="cp password-img img-responsive cp" (click)="toggleShowConfirm()">
                                
                </div>
                <span class="error-msg" *ngIf="showconfirmpassErrorMsg">Please Enter Confirm Password</span>
  
                <div class="col-12 col-sm-12 col-md-12 col-lg-12" style="color: red;" *ngIf="error6">
                    {{error6}}
                  </div> 
            
    
                <div class="mt-3">
                  <div class="row">
                    
                 
                      <div class="col-sm-12 col-md-12">
                        <div class="clear10"></div>
                        <div class="text-right">
                          <label class="fs-14 regular link cp olnone" routerLink="/forgot-password">Forgot password</label>
                      </div>
                        <div class="clear10"></div>
                        <a class="btn btn-block blue-btn semi-bold fs-16"  (click)="passwordChange()">UPDATE PASSWORD</a>
                       
                      </div>
                 </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>  
  </body>
  
  